import React, {useState, useEffect} from 'react'
import cn from "classnames"
import pageBg from  '../../img/camp-bg.webp'
import modalBg from '../../img/waterfall-modal-bg.svg'
import contentImg1 from '../../img/markov_3.webp'
import {Preloader, SpriteSvg} from '../../components'
import sun2 from "../../img/sun2.png";
import sun3 from "../../img/sun3.png";
import sun4 from "../../img/sun4.png";
import sun5 from "../../img/sun5.png";
import sun6 from "../../img/sun6.png";
import {useMousePosition} from '../../utils'
import bgImg1 from "../../img/camp-bgImg1.webp";

const CampPage = ({
	handleNextPage,
	name,
	isLoaded,
	setIsLoaded,
	isRouteTraveled,
	setIsRouteTraveled,
	campPage,
	afterCampGamePage,
}) => {

const [isVisibleContent, setIsVisibleContent] = useState(false)
const [isVisiblePage, setIsVisiblePage] = useState(true)
const [isVisibleGame, setIsVisibleGame] = useState(false)
const [modalContentChange, setModalContentChange] = useState('1')

	useEffect(()=> {
		window.TN_CLOTHERS.run("#area");
		setTimeout(()=> {
			setIsVisibleContent(true)
		},7000)
	},[])

	const handleMeadowGame = () => {
		setIsVisiblePage(false)
		setIsVisibleGame(true)
		window.TN_CLOTHERS.showStartMessage()
		window.TN_CLOTHERS.successCallback = () => {
			setIsRouteTraveled([...isRouteTraveled, campPage])
			setIsVisibleGame(false)
			handleNextPage(afterCampGamePage)
		}
	}
	const position = useMousePosition()
	return (
		<>
		<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>
			<div id='area' className={cn(
				'game-wrap',
				isVisibleGame && 'active'
			)}></div>

			{isVisiblePage &&
		<div className={cn(
					 'full-page',
					 'peacs-page',
					 isLoaded && 'active'
				 )}
		>
			<div className="page-bg right-sun">
				<img className='bg-img' src={pageBg} alt=""/>
				<img className='sun2' style={{transform: `translate(-${position.x / 10}px, -${position.y / 10}px)`}} src={sun2} alt=""/>
				<img className='sun3' style={{transform: `translate(-${position.x / 25}px, -${position.y / 25}px)`}} src={sun3} alt=""/>
				<img className='sun4' style={{transform: `translate(-${position.x / 50}px, -${position.y / 50}px)`}} src={sun4} alt=""/>
				<img className='sun5'  src={sun5} alt=""/>
				<img className='sun6' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px)`}} src={sun6} alt=""/>
				<img className='camp-bgImg1' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px)`}} src={bgImg1} alt=""/>
			</div>

			<div className={cn(
						 'page-content',
						 isVisibleContent &&
						 'active'
					 )}>

				<div className={cn(
					'modal',
					modalContentChange !== '1' &&
					'disabled'
				)}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>


					<div className={cn(
						'modal-content'
					)}
					>
						<div className="text">
							<p className='mg-b-24'>Твоему рвению можно позавидовать. Но подъём — это не только физическая сила, но и крепость духа! А ещё — возможность предугадывать будущие испытания.</p>
							<p className='mg-b-24'>На вершине очень холодно. Пора раздобыть тёплую одежду! Впереди — перевалочный лагерь.</p>
						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> setModalContentChange('2')} className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<span>Поспешим!</span>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'modal',
					modalContentChange !== '2' &&
					'disabled'
				)}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>

					<div className={cn(
						'modal-content',
					)}
					>
						<div className="text">
							<p className='mg-b-24'>К счастью, местные девушки могут нам помочь с тёплой одеждой. В их домике есть чулан, где могут найтись нужные тебе вещи. Но получишь ты их только при одном условии — нужно помочь девушкам разобрать тяжёлые вещи.</p>
								<p className='mg-b-24'>Удачи. Встретимся чуть позже!</p>

						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> handleMeadowGame()} className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<p>Прокачать силу и одеться</p>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'content',
					'center',
				)}>
					<div className="img-wrap">
						<img src={contentImg1} alt=""/>
					</div>

				</div>

			</div>

		</div>
			}
		</>
	)
}

export default CampPage